module.exports = __webpack_public_path__ + "static/auditorium@2x.d572a033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/auditorium@2x.jpg
// module id = 138
// module chunks = 35783957827783 126667273374311